module.exports = __webpack_public_path__ + "img/iphonexr_splash.ad22bbe8.png";